/**
 * Table styled components
 * @module wellRegistrationTotals/styled/table
 */

import styled from "styled-components/macro";
import { TableContainer } from "@material-ui/core";

/**
 * Main registration table container with row styling
 */
export const StyledTableContainer = styled(TableContainer)`
  margin-top: ${(props) => props.theme.spacing(2)}px;

  .MuiTableCell-root {
    border: 1px solid rgba(224, 224, 224, 1);
    padding: 8px;
  }

  .MuiTableHead-root {
    background-color: #e3f2fd;

    .MuiTableCell-head {
      font-weight: 600;
      text-align: center;
    }
  }

  .group-header {
    background-color: #90caf9;
    text-align: center;
    font-weight: 600;
  }

  .subtotal-row {
    background-color: #f5f5f5;
    font-weight: 600;
  }

  .grand-total-row {
    background-color: #e0e0e0;
    font-weight: 600;
  }

  .month-row {
    &:hover {
      background-color: #f5f5f5;
    }
  }

  .adjustment-row {
    color: #d32f2f;

    .MuiTableCell-root {
      color: #d32f2f;
    }
  }

  .clickable-row {
    cursor: pointer;
    &:hover {
      background-color: #e3f2fd;
    }
  }

  .selected-row {
    background-color: #bbdefb !important;
  }

  @media print {
    .selected-row {
      background-color: transparent !important;
      background: none !important;
    }
  }
`;

/**
 * Drilldown table container with orange header theme
 */
export const DrilldownTableContainer = styled(TableContainer)`
  .MuiTableCell-root {
    border: 1px solid rgba(224, 224, 224, 1);
    padding: 8px;
  }

  .MuiTableHead-root {
    background-color: #fff3e0;

    .MuiTableCell-head {
      font-weight: 600;
      text-align: center;
    }
  }
`;
